import * as queryString from 'query-string';
import { call, debounce, put, select, takeLatest, throttle } from 'typed-redux-saga';
import { logError } from '../../../utils/log';
import { apiClientRequest, getApiErrorMessage } from '../../services/ApiClient';
import { optionListNotifications } from './notification';
import { selectInitialized, selectFilterData, selectPagination } from './selectors';
import { actions } from './slice';
import { OptionListInitialized } from './types';

export function* getOptionList() {
    try {
        const initialized: OptionListInitialized = yield* select(selectInitialized);
        const can = initialized.sorting;
        if (!can) return;

        const filterData = yield* select(selectFilterData);
        const pagination = yield* select(selectPagination);

        const params = {
            query: filterData.searchText,
            isActive: filterData.isActiveOnly === true ? true : undefined,
            sortBy: filterData.sortBy,
            sortOrder: filterData.sortOrder,
            page: pagination.page,
            pageSize: pagination.pageSize,
        };

        const requestData = {
            requestId: 'optionList',
            query: queryString.stringify(params, {
                skipNull: true,
                sort: false,
            }),
        };

        const result = yield* call(apiClientRequest, requestData);
        yield* put(actions.getOptionListSuccess(result));
    }
    catch (error) {
        logError({
            error,
            target: 'OptionListPage.getOptionList',
        });
        yield* put(actions.getOptionListError());
        const message = getApiErrorMessage(error);
        yield* put(optionListNotifications.unknownError(message));
    }
}

export function* getOptionListSaga() {
    yield* takeLatest(actions.getOptionList, getOptionList);

    function* requestGetOptionList() {
        yield* put(actions.getOptionList());
    }

    yield* throttle(1000, [
        actions.setPage,
        actions.setSorting,
    ], requestGetOptionList);

    yield* debounce(1000, [
        actions.setFilterData,
        actions.setPageSize,
    ], requestGetOptionList);
}
